const environments = {
development: {
apiUrl: 'http://localhost:3000',
baseUrl: 'http://localhost:3000/',
portalUrl: 'http://localhost:8000/',
candidateUrl: 'http://localhost:5000/',
webUrl: 'http://localhost:9000/',
appVersion: '1.0.0',
},

production: {
apiUrl: 'https://api.aplini.com',
baseUrl: 'https://api.aplini.com/',
portalUrl: 'https://portal.aplini.com/',
candidateUrl: 'https://candidate.aplini.com/',
webUrl: 'https://aplini.com/',
appVersion: '1.0.0',
}
};

const MODE = 'production';

export const environment = environments[MODE];